<!-- <template >
  <div class="world-tile">
  <img src="https://d2w9rnfcy7mm78.cloudfront.net/2663713/original_5961e121e6b2cc91b90ce77bda1563f8.jpg
  " width="110px"/>
  <p><a href="">BOB</a> </p>
</div>
</template> -->

<template >
  <div class='world-tile'>
    <a :href='pageLink'><img :src="image" /></a>
    <p><a :href='pageLink'>{{title}}</a></p>
  </div>

</template>

<script>
export default {
  name: 'WorldTile',
  props: ['title', 'image', 'pageLink'],
  methods: {
    imgLoaded () {
      console.log('image loaded')
    }
  }
}
</script>

<style scoped>
  .world-tile {
      float: left;
      width: 250px;
      min-width: 120px;
      text-align: center;
      font-weight: bold;
    box-shadow: 3px 3px 8px #ddd;
      border: 1.2px solid rgb(204, 204, 204);
      border-radius: 4px;
      margin: 4px;
      padding: 4px;
      background-color: #fafafa;
  }
  .world-tile img {
      display: inline-block;
      width: 98%;
      border-radius: 4px;
  }

  .world-tile p {
    padding-top: 0.1em;
    padding-bottom: 0.2em;
    margin: 0em;
    vertical-align: middle;
    line-height: 94%;
  }

  .world-tile:hover{
    background-color:#e1e1e1;

  }

a {
  font-family: sans-serif;
  font-size: 0.8em;
  letter-spacing: -0.2px;
  line-height: 2%;
}

a:visited {
  color: blue;

}

a:hover {
  color: white;
}

@media only screen and (max-width: 500px) {
   .world-tile {

      width: 20%;
      min-width: 80px;

  }

}

</style>
